import React, { useEffect, useState } from "react";
import ContentCard from "../../../components/misc/ContentCard";
import TextInput from "../../../components/misc/TextInput";
import CustomButton from "../../../components/CustomButton";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import {
  fetchDownloadHistoryTemperatureRaport,
  fetchPackageHistory,
  fetchPackageHistoryWithActions,
} from "../../../redux/api/raports.api";
import { getDateAndTime } from "../../../utils/dateAndTime";
import {
  clearPackageHistory,
  clearPackageHistoryWithActions,
} from "../../../redux/reducer/raports.reducer";
import LoadingIndicator from "../../../components/misc/LoadingIndicator";
import Dropdown, { DropdownValue } from "../../../components/misc/Dropdown";

const getPackageHistoryType = (item: any) => {
  const type = item.tip;
  switch (type) {
    case "creat":
      return (
        <p>
          Coletul a fost pregatit de clientul{" "}
          <span className="fw-bolder">{item.denumire}</span> cu ridicare de la{" "}
          <span className="fw-bolder">{item.preluare}</span> in data de{" "}
          <span className="fw-bolder">
            {getDateAndTime(item.data_incarcare)}
          </span>
        </p>
      );

    case "auto":
      return (
        <p>
          Coletul a fost incarcat in masina{" "}
          <span className="fw-bolder">{item.denumire}</span> de catre{" "}
          <span className="fw-bolder">
            {item.nume} {item.prenume}
          </span>{" "}
          la data de{" "}
          <span className="fw-bolder">
            {getDateAndTime(item.data_incarcare)}
          </span>
        </p>
      );

    case "nod":
      return (
        <p>
          {item.id_bin ? "Coletul a intrat" : "Coletul a fost scanat"} in nodul{" "}
          <span className="fw-bolder">{item.denumire}</span> la data de{" "}
          <span className="fw-bolder">
            {getDateAndTime(item.data_incarcare)}
          </span>
        </p>
      );

    case "livrat":
      return (
        <p>
          Coletul a fost livrat la{" "}
          <span className="fw-bolder">{item.denumire}</span> la data de{" "}
          <span className="fw-bolder">
            {getDateAndTime(item.data_descarcare)}
          </span>{" "}
          {item.motiv && (
            <>
              cu motivul <span className="fw-bolder">"{item.motiv}"</span>
            </>
          )}
        </p>
      );

    default:
      return "Nu exista";
  }
};

const getPackageHistoryTypeWithActions = (item: any) => {
  const type = item.task_type;
  let statusDescription = "";
  switch (type) {
    case 1:
      statusDescription = "Creeaza trasabilitate";
      break;

    case 2:
      statusDescription = "Incarca colet in masina";
      break;

    case 3:
      statusDescription = "Schimbare data ridicare";
      break;

    case 4:
      statusDescription = "Finalizare livrare";
      break;

    case 5:
      statusDescription = "Anulare awb";
      break;

    default:
      return "Nu exista";
  }

  return (
    <p>
      <span className="fw-bolder">
        {item.nume} {item.prenume}
      </span>{" "}
      a apasat butonul <span className="fw-bolder">"{statusDescription}" </span>
      la data de
      <span className="fw-bolder"> {getDateAndTime(item.ts_operatie)}</span>
    </p>
  );
};

function PackageHistory() {
  const dispatch = useAppDispatch();

  const {
    raports: {
      packageHistory: {
        data: packageHistory,
        isLoading: isLoadingPackageHistory,
      },
      packageHistoryWithActions: {
        data: packageHistoryWithActions,
        isLoading: isLoadingPackageHistoryWithActions,
      },
    },
  } = useAppSelector((state) => ({
    raports: state.raports,
  }));

  const [awbOrInvoiceNumber, setAwbOrInvoiceNumber] = useState<
    string | number | null
  >(null);
  const [selectedAwb, setSelectedAwb] = useState<DropdownValue | null>(null);

  const handleSearchPackageHistoryByAwbOrInvoiceNumber = () => {
    if (awbOrInvoiceNumber) {
      dispatch(
        fetchPackageHistory({
          doc_trans: awbOrInvoiceNumber,
        }),
      );
      dispatch(
        fetchPackageHistoryWithActions({
          doc_trans: awbOrInvoiceNumber,
        }),
      );
    }
  };

  useEffect(() => {
    if (packageHistory.length > 0) {
      setSelectedAwb({
        id: packageHistory[0].awb,
        label: packageHistory[0].awb,
      });
    }
  }, [packageHistory]);

  useEffect(() => {
    return () => {
      dispatch(clearPackageHistory());
      dispatch(clearPackageHistoryWithActions());
    };
  }, [dispatch]);

  const showDownloadButton =
    packageHistory.length > 0 && !isLoadingPackageHistory;

  const handleDownloadTemperatureReport = () => {
    if (selectedAwb?.id) {
      dispatch(
        fetchDownloadHistoryTemperatureRaport({
          awb: selectedAwb?.id,
        }),
      );
    }
  };

  const selectedPackageHistory =
    packageHistory?.find((item) => item.awb === selectedAwb?.id)?.actiuni ?? [];
  const selectedPackageHistoryWithActions =
    packageHistoryWithActions?.find((item) => item.awb === selectedAwb?.id)
      ?.actiuni ?? [];

  const awbList = packageHistory.map((item) => ({
    id: item.awb,
    label: item.awb,
  }));

  return (
    <div>
      <ContentCard cardTitle="Cauta istoricul unui colet dupa awb sau nr. factura">
        <div className="d-flex align-items-center">
          <TextInput
            type="text"
            placeholder="Introduceti awb-ul sau nr. facturii"
            name="awbOrInvoiceNumber"
            value={awbOrInvoiceNumber}
            onChange={(value) => setAwbOrInvoiceNumber(value)}
            withVerticalSpacer
            withUpperCasing
          />

          <CustomButton
            variant="contained"
            className="ms-2 mb-7"
            style={{ height: 50, width: 100 }}
            onClick={handleSearchPackageHistoryByAwbOrInvoiceNumber}>
            Cauta
          </CustomButton>
        </div>
        {awbList.length > 0 && (
          <Dropdown
            title="Cauta AWB"
            className=""
            data={awbList}
            singleValue={selectedAwb}
            setSingleValue={setSelectedAwb}
          />
        )}
      </ContentCard>

      {isLoadingPackageHistory && (
        <div className="d-flex justify-content-center align-items-center">
          <LoadingIndicator />
        </div>
      )}

      <div className="d-flex flex-column flex-md-row">
        {selectedPackageHistory.length > 0 && !isLoadingPackageHistory && (
          <ContentCard
            cardTitle="Istoricul coletului"
            fullWidth
            cardContainerStyle={{ minWidth: 400 }}>
            {selectedPackageHistory.map((item, idx) => {
              return (
                <ContentCard
                  key={idx}
                  withPadding={false}
                  withMargin={false}
                  className="px-5 py-2 my-5">
                  <div className="d-flex flex-row align-items-center pt-3">
                    <p className="me-2">{idx + 1}.</p>
                    {getPackageHistoryType(item)}
                  </div>
                </ContentCard>
              );
            })}
          </ContentCard>
        )}

        {selectedPackageHistoryWithActions.length > 0 &&
          !isLoadingPackageHistoryWithActions && (
            <ContentCard
              cardTitle="Actiuni pe colet"
              fullWidth
              cardContainerStyle={{ minWidth: 400 }}>
              {selectedPackageHistoryWithActions.map((item, idx) => {
                return (
                  <ContentCard
                    key={idx}
                    withPadding={false}
                    withMargin={false}
                    className="px-5 py-2 my-5">
                    <div className="d-flex flex-row align-items-center pt-3">
                      <p className="me-2">{idx + 1}.</p>
                      {getPackageHistoryTypeWithActions(item)}
                    </div>
                  </ContentCard>
                );
              })}
            </ContentCard>
          )}
      </div>

      {showDownloadButton && (
        <div className="d-flex justify-content-center align-content-center">
          <CustomButton
            variant="contained"
            className="mx-auto"
            onClick={handleDownloadTemperatureReport}>
            Descarca diagrama temperatura
          </CustomButton>
        </div>
      )}
    </div>
  );
}

export default PackageHistory;
